import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { DriveOnDisplayableTaskDto as DriveOnTask } from '@/generated/model';
import { ChooseTask } from '@/components/logbook/task/ChooseTask';
import { DialogContent } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

import './ChooseTaskDialog.css';

type ChooseTaskDialogProps = {
  onClose: (task: DriveOnTask | undefined) => void;
};

export function ChooseTaskDialog({ onClose }: ChooseTaskDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog sx={{ '& .MuiDialog-paper': { height: '80%' } }}  open={true} >
      <DialogContent dividers className="task-content">
        <ChooseTask onSelect={onClose} />
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={() => onClose(undefined)}
          startIcon={<ClearIcon />}
           sx={{ 
            color: 'white', 
            backgroundColor: 'red !important' }}
        >
          {t('general.cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
